import { render, staticRenderFns } from "./CustomerGroup.vue?vue&type=template&id=0b716473&"
import script from "./CustomerGroup.vue?vue&type=script&lang=js&"
export * from "./CustomerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports